export default __webpack_public_path__ + "static/hero-career-adv-4-0e9e8d487c9b203b011539435abbd04a.webp";